export default __webpack_public_path__ + "images/KL.c838e38.png";